var _objectSpread = require("/Users/dandregregory/workspace/EEMERGPLATFORM/SP_SIGNUP_APP/node_modules/react-scripts/node_modules/@babel/runtime/helpers/objectSpread");

var _require = require('../util'),
    looseEqual = _require.looseEqual;

var types = require('./types');

var CUSTOM = function CUSTOM(val, f, obj) {
  return f(val, obj);
};

var OPTIONAL = function OPTIONAL(val, state) {
  return val === undefined && state === true;
};

var oneOf = function oneOf(val, arr) {
  for (var i = 0; i < arr.length; i += 1) {
    if (looseEqual(arr[i], val)) {
      return true;
    }
  }

  return false;
};

var TEST_FUNCTIONS = _objectSpread({}, types);

Object.keys(TEST_FUNCTIONS).forEach(function (key) {
  TEST_FUNCTIONS[key].custom = CUSTOM;
  TEST_FUNCTIONS[key].optional = OPTIONAL;
  TEST_FUNCTIONS[key].oneOf = oneOf;
});
module.exports = {
  TEST_FUNCTIONS: TEST_FUNCTIONS,
  OPTIONAL: OPTIONAL
};